module.exports = __webpack_public_path__ + "img/biodigital.42e748ad.jpg";